module.exports = "/_next/static/images/7873ee3fbfbcf868613cf7f9b1c0f94e-sanpablo-2.jpg.webp";